import { createAsyncThunk } from '@reduxjs/toolkit';

import { AccountService } from 'api';

import { asyncPayloadCreator } from 'utils';

export const checkResetPasswordToken = createAsyncThunk(
	'forgotPassword/checkResetPasswordToken',
	(credentials: string, { rejectWithValue }) =>
		asyncPayloadCreator(credentials, { rejectWithValue }, AccountService.checkResetPasswordToken),
);
